import React from 'react'

const ErrorMessage = () => {
  return (
    <div
      className="py-60"
      style={{ minHeight: '50vh' }}
    >
      <p className="text-center text-32 md:text-56 font-black text-depths mt-0 mb-8">
        We're sorry...
      </p>

      <p className="text-center text-20 md:text-24 font-black text-depths mb-32 mt-8">
        Something went wrong.
      </p>

      <p className="text-center text-16 text-depths">
        Please refresh the page and try again.
      </p>
    </div>
  )
}

export default ErrorMessage
